import { render, staticRenderFns } from "./MensajeNombresDuplicados.vue?vue&type=template&id=6c39b4fa"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports